import PropTypes from 'prop-types';
import { StepContext } from '../StepContext';

export const Step = ({ activeStep = 0, children, classes = {}, components = {}, stepIndex = 0, ...props }) => {
  // assign default components
  const StepComp = components.StepComp ?? 'div';
  const StepConnectorComp = components.StepConnectorComp ?? 'div';

  return (
    <StepContext.Provider
      value={{
        stepIndex,
        activeStep
      }}
    >
      {stepIndex !== 0 && <StepConnectorComp className={classes.stepConnector} />}
      <StepComp {...props} className={classes.step}>
        {children}
      </StepComp>
    </StepContext.Provider>
  );
};

Step.defaultProps = {
  activeStep: 0,
  classes: {},
  components: {},
  stepIndex: 0
};

Step.propTypes = {
  activeStep: PropTypes.number,
  /** Child elements. This is where your AccordionPanels go. */
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.func,
    PropTypes.arrayOf(PropTypes.func)
  ]).isRequired,
  classes: PropTypes.object,
  /** Optional overrides to default HTML elements used */
  // @ts-expect-error
  components: PropTypes.shape({
    /** Styled or non styled component */
    StepComp: PropTypes.elementType,
    StepConnectorComp: PropTypes.elementType
  }),
  stepIndex: PropTypes.number
};
